import { WatcherFunction } from '@sagas'
import { watchCreatorBio } from './creator-bio'

export const creatorBioSagas: ReadonlyArray<WatcherFunction> = [watchCreatorBio]
